<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'BengkelRekanan',

    metaInfo: { title: 'Bengkel Rekanan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'autoshop',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'autoshop',
      },
    },
  }
</script>
